import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Header } from "../../../components/header";
import { CardHeader } from "../../../components/cards";
import { SendIcon } from "../../../components/icons";
import { Loading } from "../../../components/loading";
import { Input, Select, Textarea } from "../../../components/form";
import { Button } from "../../../components/button";
import { useArticle, useUpdateArticle } from "../hooks";
import { CustomerSelectSearch } from "../../customers/components";
import { ArticleType } from "../../../__generated__/globalTypes";
import { articleTypeLabel } from "../../../helpers/enum-labels";

type IUpdateArticle = {
  id: string;
};

export const UpdateArticle: React.FC = () => {
  const { id } = useParams<IUpdateArticle>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      navigate("/");
    }
  }, []);

  const { data, refetch } = useArticle(+id!);
  const { form, submit, loading } = useUpdateArticle({
    id: +id!,
    onCompleted: () => {
      refetch();
      toast.success("L'article a été modifié avec succès");
    },
  });

  useEffect(() => {
    if (data?.article?.ok && data?.article?.result) {
      const { result } = data.article;
      form.setValue("customerId", result.customerId);
      form.setValue("site", result.site);
      form.setValue("type", result.type);
      form.setValue("title", result.title);
      form.setValue("content", result.content);
    }
  }, [data]);

  if (!data) {
    return <Loading />;
  }

  const article = data?.article?.result;

  return (
    <>
      <Header
        title="Article"
        subtitle={article?.title ?? ""}
        buttons={[
          {
            actionText: "Annuler",
            bgColor: "indigo",
            textColor: "white",
            link: `/articles`,
            icon: <SendIcon />,
          },
        ]}
      />
      <div className="main-container">
        <div className="card">
          <CardHeader title="Modifier un article" />
          <div className="w-full">
            <div className="flex flex-wrap gap-3">
              <CustomerSelectSearch form={form} name="customerId" />
              <Input label="Site" className="w-full" {...form.register("site")} />
              <Select label="Type" className="w-full" {...form.register("type")}>
                {Object.keys(ArticleType).map((key) => (
                  <option key={key} value={key}>
                    {articleTypeLabel(key)}
                  </option>
                ))}
              </Select>
              <Input label="Titre" className="w-full" {...form.register("title")} />
              <Textarea label="Contenu" className="w-full" {...form.register("content")} />
            </div>
            <div className="w-full mt-4">
              <Button onClick={submit} loading={loading} disabled={loading}>
                Valider
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
